import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFireDatabase } from 'angularfire2/database'


@Pipe({
  name: 'filtrarCargasDeGasolina'
})
export class  FiltrarCargasDeGasolinaPipePorUnidad implements PipeTransform {
    constructor(public af:AngularFireDatabase){}
    transform(arregloCG:Array<any>, idUnidad:any): any {
    // Arreglo de unidades que se van a mostrar
    let unidadesFiltradas:Array<any> = [];
    // Hace un loop por las unidades proporcionados para poder filtrarlos por id de unidad
    if(arregloCG !=   undefined)
        arregloCG.forEach(viaje => {
            if(idUnidad != ''){
                if(viaje.unidad == idUnidad)
                    unidadesFiltradas.push(viaje)
            }else{
                unidadesFiltradas= arregloCG
            }               
        });
    return unidadesFiltradas;
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtrar-cargas-de-gasolina-por-unidad.pipe.ts